import { Component, forwardRef, inject, signal } from '@angular/core';
import { NgIcon } from '@ng-icons/core';
import { ImageSliderComponent } from '../image-slider/image-slider.component';
import { BbitImageOverlayItem, ImageOverlayRef } from './image-overlay.ref';

@Component({
  selector: 'app-image-overlay',
  templateUrl: './image-overlay.component.html',
  styleUrl: './image-overlay.component.scss',
  imports: [NgIcon, forwardRef(() => ImageSliderComponent)],
})
export class ImageOverlayComponent {
  private _overlayRef = inject(ImageOverlayRef);
  public items = signal<BbitImageOverlayItem[]>([]);
  public currentIndex = 0;
  constructor() {
    this.items.set(this._overlayRef.getItems());
    this.currentIndex = this._overlayRef.getCurrentIndex() || 0;
  }
  close() {
    this._overlayRef.close();
  }
}
